import { getGridStringOperators } from '@mui/x-data-grid-pro'
import { t } from 'i18next'

import { QuestionListColumnType } from '../questionListDataGridColumns'

export const topicIndexColumnModel: QuestionListColumnType = {
  field: 'topic',
  width: 150,
  sortable: false,
  filterable: false,
  filterOperators: getGridStringOperators().filter((operator) => operator.value === 'contains' || operator.value === 'equals'),
  valueGetter (params) {
    return params.row?.topic?.index ? t('common.topicWithIndex', { index: params.row.topic.index }) : '-'
  }
}
